import React from 'react';

class Page404 extends React.Component{
	constructor(props) {
		super(props);
		this.state = {};

	};

	componentWillMount() {
	};

	render(){
		return <div className='wrap' style={{textAlign:'center'}}>
                   <img width="400" height="400" 
                   style={{margin:'100px auto 10px',display: 'block',}}
                   src={`${window.yhtUserCenterBaseUrl}/style/images/404.png`}/> 
                </div>

	}
}

export default Page404;